import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext.jsx";
import { Input } from "@/components/ui/input.jsx";
import { Button } from "@/components/ui/button.jsx";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card.jsx";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [sessionExpired] = useState(() => sessionStorage.getItem("bc_session_expired") === "1");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const userData = await login(email, password);
      sessionStorage.removeItem("bc_session_expired");
      // Redirect based on role
      if (userData?.role === "cad_uploader") {
        nav("/cad-portal");
      } else if (userData?.role === "user" || userData?.role === "viewer") {
        nav("/mobile-upload");
      } else {
        nav("/");
      }
    } catch (err) {
      setError("Login fehlgeschlagen. Bitte prüfen Sie E-Mail und Passwort.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
      <Card className="w-full max-w-md shadow-xl">
        <CardHeader className="space-y-6">
          <div className="flex justify-center py-4">
            <img 
              src="/assets/MPS_white_BG_Logo.png" 
              alt="Moebus Productivity Suite" 
              className="w-full max-w-md h-auto object-contain"
            />
          </div>
          <CardTitle className="text-2xl text-center font-bold">Anmeldung</CardTitle>
        </CardHeader>
        <CardContent>
          {sessionExpired && (
            <div
              className="mb-4 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-800"
              data-testid="session-expired-banner"
            >
              Deine Sitzung ist abgelaufen. Bitte melde dich neu an.
            </div>
          )}
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label className="text-sm">E-Mail</label>
              <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" required />
            </div>
            <div>
              <label className="text-sm">Passwort</label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
            </div>
            {error && <div className="text-red-600 text-sm">{error}</div>}
            <Button type="submit" className="w-full" disabled={loading}>{loading ? "Anmelden…" : "Anmelden"}</Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
